import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import BrandStory from './components/BrandStory';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于我们 - 踩蘑菇攻略大全"
        description="了解踩蘑菇攻略大全的品牌故事、团队介绍和玩家口碑。我们致力于为每一位踩蘑菇玩家提供最全面、最专业的游戏攻略内容。"
        keywords="踩蘑菇,关于我们,踩蘑菇攻略团队,踩蘑菇品牌故事,踩蘑菇联系"
        canonicalUrl="https://jlsdfdl.cn/about"
      />
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 踩蘑菇攻略大全',
        description: '了解踩蘑菇攻略大全的品牌故事、团队介绍和玩家口碑。',
        url: 'https://jlsdfdl.cn/about',
        inLanguage: 'zh-CN',
      }} />
      <SchemaOrg type="Organization" data={{
        name: '踩蘑菇攻略团队',
        url: 'https://jlsdfdl.cn/',
        description: '专注踩蘑菇游戏攻略的创作与分享团队，成立于2024年，已帮助超过50万玩家提升游戏水平。',
        foundingDate: '2024',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: 'contact@jlsdfdl.cn',
        },
      }} />
      <Navbar />
      <main className="pt-24 pb-14 md:pb-16 bg-background-50 min-h-screen">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]} />
          <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">关于我们</h1>
          <p className="text-sm text-foreground-500 mb-10">了解踩蘑菇攻略大全背后的故事</p>

          <div className="space-y-12">
            <BrandStory />
            <Testimonials />
            <ContactForm />
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}